import React from "react"
import { useChecklistAPI } from "../../../contexts/checklistContext"
import BaseHoverIcon from "../../tableTemplates/icons/hoverIcon"

const HoverIcon = ({ icon, message = 'N/A', onClickHandler }) => {
  const { toggleToolTip, updateToolTipInfo } = useChecklistAPI()

  return <BaseHoverIcon icon={ icon } message={ message } onClickHandler={ onClickHandler } toggleFunc={ toggleToolTip }
                        updateFunc={ updateToolTipInfo }/>
}

export default HoverIcon
